import { useState } from "react";
import { Plus, Minus } from "lucide-react";

/* Lightweight accordion FAQ.
   Pass `items={[{ q, a }, ...]}` and an optional `title`.
   First item starts open for visual rhythm.
*/
const FaqItem = ({ q, a, defaultOpen = false, index }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div className="border-b border-brand-navy/[0.08] last:border-b-0">
            <button
                type="button"
                onClick={() => setOpen((s) => !s)}
                data-testid={`faq-toggle-${index}`}
                aria-expanded={open}
                className="w-full flex items-start gap-4 py-5 sm:py-6 text-left focus:outline-none group"
            >
                <span className="flex-1 font-heading text-[17px] sm:text-[18px] font-bold text-brand-navy leading-snug tracking-tight pr-4">
                    {q}
                </span>
                <span
                    className={`shrink-0 h-8 w-8 rounded-full bg-brand-offWhite border border-brand-navy/[0.10] inline-flex items-center justify-center transition-all ${open ? "bg-brand-coral border-brand-coral text-white rotate-180" : "text-brand-navy"}`}
                >
                    {open ? <Minus size={14} strokeWidth={2.25} /> : <Plus size={14} strokeWidth={2.25} />}
                </span>
            </button>
            <div
                className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100 pb-5 sm:pb-6" : "grid-rows-[0fr] opacity-0"}`}
            >
                <div className="overflow-hidden">
                    <p className="text-[15px] text-[#334155] leading-[1.65] max-w-2xl">{a}</p>
                </div>
            </div>
        </div>
    );
};

const FAQ = ({ title = "Questions parents may have", intro, items = [], testId }) => {
    return (
        <section data-testid={testId || "faq"} className="container-tp pb-12 md:pb-16">
            <div className="connected-section">
                <div className="max-w-2xl mb-2 md:mb-4">
                    <h2 className="h2">{title}</h2>
                    {intro && <p className="body-prose mt-3">{intro}</p>}
                </div>
                <div className="mt-2">
                    {items.map((it, i) => (
                        <FaqItem
                            key={it.q || `faq-${i}`}
                            index={i}
                            defaultOpen={i === 0}
                            {...it}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
